import {Box, CircularProgress, Backdrop, Typography} from '@mui/material';
import {enqueueSnackbar} from 'notistack';
import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useQueryClient} from 'react-query';
import {useNavigate, useSearchParams} from 'react-router-dom';
import useCancelNamePurchase from 'src/namePurchase/data-access/useCancelNamePurchase';
import useOauthHandleForNamePurchase from 'src/namePurchase/data-access/useOauthHandleForNamePurchase';
import {USER_DATA_INFO_QUERY_KEY} from 'src/shared/enums/useQueryKeys';

export default function OauthHandler() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

    const queryClient = useQueryClient();

    const {error: error, data: data} = useOauthHandleForNamePurchase(
        searchParams.get('mode'),
        searchParams.get('oauth_token'),
        searchParams.get('oauth_verifier')
    );

    const {mutate: cancelNamePurchase} = useCancelNamePurchase({
        nameTitlePurchaseAppId: data?.data?.nameTitlePurchaseAppId,
    });
    useEffect(() => {
        if (data) {
            if (data?.data?.afmExists) {
                enqueueSnackbar(t(data?.data?.message), {variant: 'error'});
                if (searchParams.get('mode') == 'directPurchase')
                    navigate('/namePurchase/directPurchase');
                else navigate('/');
            } else if (
                data?.data?.afm &&
                searchParams.get('mode') == 'directPurchase'
            ) {
                navigate('/namePurchase/directPurchaseUserForm', {
                    state: {afm: data?.data?.afm},
                });
            } else if (searchParams.get('mode') == 'companyNameApprover') {
                queryClient.invalidateQueries({
                    queryKey: [USER_DATA_INFO_QUERY_KEY],
                    exact: false,
                });
                navigate('/namePurchase/approverRequestView');
            } else if (
                data?.data?.afm &&
                searchParams.get('mode') == 'namePurchaseUse'
            ) {
                navigate('/namePurchase/usePurchaseForm', {
                    state: {afm: data?.data?.afm},
                });
            } else if (searchParams.get('mode') == 'cancelNameTitleApp') {
                cancelNamePurchase();
            }
        }

        if (error) {
            if (!data?.data?.message) {
                enqueueSnackbar(t('Προέκυψε κάποιο τεχνικό πρόβλημα'), {
                    variant: 'error',
                });
            } else {
                enqueueSnackbar(t(data?.data?.message), {variant: 'error'});
            }

            if (searchParams.get('mode') == 'directPurchase')
                navigate('/namePurchase/directPurchase');
            else if (searchParams.get('mode') == 'namePurchaseUse')
                navigate('/namePurchase/usePurchase');
            else if (searchParams.get('mode') == 'cancelNameTitleApp')
                navigate(`/namePurchase/companyNames`);
        }
    }, [data, error]);

  return (
    <Box>
      <Typography variant="body1">
        {t("Περιμένετε να γίνει η διασταύρωση των στοιχείων...")}
      </Typography>

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
}
